import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import FontAwesome from 'react-fontawesome';
import Spinner from '~/Components/Global/Loading/Spinner';
import { errorApi } from '~/Providers/Api';
import { error } from '~/Redux/Modules/Notifications';
import Store from '~/Redux/Store';

import config from '~/Config';
import LoadingMessage from '~/Components/Global/Loading/LoadingMessage';
import { googleAccount, googleCallback, updateGoogleAccount } from '~/Redux/Modules/Google';
import GoogleSignInWrapper from '~/Components/Global/GoogleSignInWrapper/GoogleSignInWrapper';
import AddAccountForm from './AddAccountForm';
import CalendarList from './CalendarList';

const GoogleWordLogo = require('./GoogleLogo2017.png');

class AddGoogleAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopupMessage: false,
      showFacebookMessage: false,
    };
  }
  componentDidMount() {
    // check for facebook browser
    if (
      window.navigator.userAgent.indexOf('FBAN') !== -1 ||
      window.navigator.userAgent.indexOf('FBAV') !== -1 ||
      window.navigator.userAgent.indexOf('Bytedance') !== -1
    ) {
      this.setState({ showFacebookMessage: true });
    }
  }

  handleGoogleSuccess = ({ code }) => {
    console.info('handleGoogleSuccess');
    const { addAccount, updateAccount, account } = this.props;
    if (account) {
      updateAccount({ id: account.id, code });
    } else {
      addAccount({ code });
    }
  };

  handleGoogleFailed = err => {
    console.error('handleGoogleFailed', JSON.stringify(err.error));
    errorApi.noticeError(err, 'handleGoogleFailed');
    Store.dispatch(error('Sorry, an error occurred', err.error));
    if (err.error == 'popup_blocked_by_browser' || err.error == 'popup_closed_by_user') {
      this.setState({ showPopupMessage: true });
    }
  };

  render() {
    const { account, isFetching, isRegistering, isUpdating } = this.props;
    const { showPopupMessage, showFacebookMessage } = this.state;
    if (isFetching) return <LoadingMessage small messages="Checking for Google account" />;
    return (
      <AddAccountForm logo={GoogleWordLogo} account={account}>
        {!account ? (
          <>
            <div className="google-sign-in-wrapper">
              <GoogleSignInWrapper
                isUpdating={isRegistering}
                addAccountScreen
                actionText="Signing In"
                disabled={showFacebookMessage || isRegistering}
                buttonText="Sign in with Google"
                onSuccess={credentialResponse => {
                  this.handleGoogleSuccess(credentialResponse);
                  console.log(credentialResponse);
                }}
                onError={err => {
                  this.handleGoogleFailed(err);
                  console.log('Login Failed');
                }}
              />
            </div>
            <div className="center">
              {showPopupMessage && (
                <p>
                  The popup was closed. Please try again and ensure your browser is not blocking
                  popups.
                </p>
              )}
              {showFacebookMessage && (
                <p className="facebook-browser-warning">
                  <FontAwesome name="exclamation-triangle" />
                  Google sign in does not work in an In-App Browser.
                  <br /> Please open this page in a separate browser or download our mobile app.
                </p>
              )}
            </div>
          </>
        ) : (
          <div className="center gray">
            <h6>Success!</h6>
            <h5>{account.email}</h5>
            <h6>is now connected to Artful Agenda!</h6>
            <CalendarList account={account} />
            <GoogleSignInWrapper
              onSuccess={credentialResponse => {
                this.handleGoogleSuccess(credentialResponse);
                console.log(credentialResponse);
              }}
              onError={err => {
                this.handleGoogleFailed(err);
                console.log('Login Failed');
              }}
              account={account}
              isUpdating={isUpdating}
            />
            <a
              target="_blank"
              className="add-calendar"
              href="https://calendar.google.com/calendar/b/0/r/settings/createcalendar"
            >
              Create Calendar
            </a>
            <a
              target="_blank"
              className="manage-calendars"
              href="https://calendar.google.com/calendar/b/0/r/settings"
            >
              Manage Calendars &amp; Sharing
            </a>
          </div>
        )}
      </AddAccountForm>
    );
  }
}

AddGoogleAccount.propTypes = {
  account: propTypes.object,
  addAccount: propTypes.func.isRequired,
  updateAccount: propTypes.func.isRequired,
  isFetching: propTypes.bool.isRequired,
  isRegistering: propTypes.bool.isRequired,
  isUpdating: propTypes.bool.isRequired,
};

const mapStateToProps = ({ Google }) => ({
  isRegistering: Google.isFetching,
  isUpdating: Google.isUpdating,
});

const mapDispatchToProps = dispatch => ({
  addAccount: data => dispatch(googleCallback(data)),
  updateAccount: data => dispatch(updateGoogleAccount(data)),
});

export default AddGoogleAccount |> connect(mapStateToProps, mapDispatchToProps);
